import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Plus, FileUser, UserRoundPen, Search } from "lucide-react";
import StudentList from "./StudentList"; // PascalCase olarak import edin
import Homework from "./Homework";
import Detail from "./Detail";
import AddClass from "./AddClass";
import api from "../utils/api";
function DynamicClassView() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectStudent, setSelectStudent] = useState(0);
  const [studentList, setStudentList] = useState(null);
  const [teacherData, setTeacherData] = useState(null);
  const [selectClassName, setSelectClassName] = useState("");
  const [selectClassId, setSelectClassId] = useState(null);
  const [classDetail, setClassDetail] = useState([]);

  //reduxtan gelen sınıf bilgisi

  const classButton = [
    {
      title: "studentList",
      icon: FileUser,
      count: 0,
    },
    {
      title: "Homework",
      icon: Plus,
      count: 1,
    },
    {
      title: "Detail",
      icon: Search,
      count: 2,
    },
    {
      title: "Add",
      icon: UserRoundPen,
      count: 3,
    },
  ];
  const selectClass = useSelector((state) => state.selectClass.value);
  // console.log(selectClass, "seçilen class");
  const className = selectClass.className;
  const classId = selectClass._id;
  const handleCreateHomework = (count) => {
    setSelectStudent(count);
  };
  useEffect(() => {
    if (className.includes(2)) {
      setSelectClassName("class 2");
    }
    if (className.includes(3)) {
      setSelectClassName("class 3");
    }
    if (className.includes(4)) {
      setSelectClassName("class 4");
    }
    setSelectClassId(classId);
  }, [selectClass]);
  //sınıf detayı almak için yapılan get isteği

  useEffect(() => {
    const handleDetailClass = async () => {
      if (!classId) {
        // console.log(selectClass, "No class Id available");
        return;
      }
      setLoading(true);
      setError(null);
      if (selectClassName) {
        try {
          const response = await api.get("detailClass", {
            params: {
              _id: selectClassId,
              className: selectClassName,
            },
          });
          if (response.status === 200) {
            // console.log(response.data, "gelen respnse data bilgisi");
            setClassDetail(response.data.detailClassForStudent);
          }
        } catch (error) {
          console.error("Öğrenci bilgisi alınamadı:", error);
          setError(error.response?.data?.message || "Bir hata oluştu");
        } finally {
          setLoading(false);
        }
      }
    };
    handleDetailClass();
  }, [selectClass]);

  // Öğretmen bilgilerini localStorage'dan al
  useEffect(() => {
    const teacher = JSON.parse(localStorage.getItem("postUser"));
    if (teacher) {
      setTeacherData({
        _id: teacher._id,
        id: teacher._id, // Fallback
        name: teacher.name || teacher.username,
        username: teacher.username,
        email: teacher.email,
      });
    }
  }, []);

  useEffect(() => {
    setStudentList(selectClass.students);
  }, [selectClass, studentList]);

  return (
    <div className="min-h-screen bg-white rounded-2xl p-6">
      <div className="max-w-4xl mx-auto">
        {/* Başlık Bölümü */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-semibold text-gray-600 mb-2">
            {selectClass.className}
          </h1>
          <p className="text-gray-600 mb-4">{selectClass.description}</p>

          {/* Genel İstatistikler */}
          <div className="flex justify-center gap-6 mb-6">
            <div className="bg-gray-100 rounded-lg p-4 shadow-md">
              <div className="text-2xl font-bold text-purple-500">
                {selectClass.students?.length || 0}
              </div>
              <div className="text-gray-600">Toplam Öğrenci</div>
            </div>
            <div className="bg-gray-100 rounded-lg p-4 shadow-md">
              <div className="text-2xl font-bold text-purple-500">
                {selectClass.maxStudents}
              </div>
              <div className="text-gray-600">Maksimum Kapasite</div>
            </div>
            <div className="bg-gray-100 rounded-lg p-4 shadow-md">
              <div className="text-2xl font-bold text-purple-500">75%</div>
              <div className="text-gray-600">Ödev Ortalaması</div>
            </div>
          </div>

          {/* Ödev Oluştur Butonu */}
          <div className="mb-6 flex gap-4 justify-center items-center">
            {classButton.map((button, index) => (
              <button
                key={index}
                onClick={() => handleCreateHomework(button.count)}
                className="bg-purple-500 text-white px-4 py-2 rounded-xl
               hover:bg-yellow-500 transition-all duration-300 font-normal text-md
              transform hover:scale-105 flex items-center space-x-3 mx-auto"
              >
                <div className="flex flex-col lg:flex-row gap-1 lg:items-center lg:justify-center">
                  <div className="flex justify-center items-center-safe">
                    <button.icon className=" w-6 h-6 " />
                  </div>
                  <span className="text-xs lg:text-md">{button.title}</span>
                </div>
              </button>
            ))}
          </div>
          <hr className="border-2 border-yellow-500 my-2" />
          <div>
            {selectStudent === 0 && (
              <StudentList
                studentList={studentList}
                classId={selectClass._id}
              />
            )}
            {selectStudent === 1 && (
              <Homework classData={selectClass} teacherData={teacherData} />
            )}
            {selectStudent === 2 && <Detail classDetail={classDetail} />}
            {selectStudent === 3 && (
              <AddClass
                capacity={selectClass.maxStudents}
                classTitle={selectClass.className}
                classDescription={selectClass.description}
                classId={selectClass._id}
                classType={selectClass.classType}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DynamicClassView;
